/*****************************************
	Date Validator
*****************************************/
($ => {
	if ($.dateValidator) {
		ui.warn('ERROR: You are including date-validator.js multiple times');
		return;
	}
	const langSets = {
		de: {
			calendarEras: {
				'v Chr': 'v. Chr.',
				'v. Chr.': 'v. Chr.',
				'v.u.Z': 'v.u.Z',
				vuZ: 'v.u.Z'
			},
			modifiers: {
				/* ungef\u00e4hr must come before ungef so that it gets iterated over first other wise it will match the other */
				circa: 'circa',
				etwa: 'etwa',
				nach: 'nach',
				ungef\u00e4hr: 'ungef\u00e4hr',
				ungef: 'ungef.',
				vor: 'vor'
			},
			months: [
				{
					abbr: 'jan',
					days: 31,
					name: 'januar'
				},
				{
					abbr: 'feb',
					days: 29,
					name: 'februar'
				},
				{
					abbr: 'm\u00e4r',
					days: 31,
					name: 'm\u00e4rz'
				},
				{
					abbr: 'apr',
					days: 30,
					name: 'april'
				},
				{
					abbr: 'mai',
					days: 31,
					name: 'mai'
				},
				{
					abbr: 'jun',
					days: 30,
					name: 'juni'
				},
				{
					abbr: 'jul',
					days: 31,
					name: 'juli'
				},
				{
					abbr: 'aug',
					days: 31,
					name: 'august'
				},
				{
					abbr: 'sep',
					days: 30,
					name: 'september'
				},
				{
					abbr: 'okt',
					days: 31,
					name: 'oktober'
				},
				{
					abbr: 'nov',
					days: 30,
					name: 'november'
				},
				{
					abbr: 'dez',
					days: 31,
					name: 'dezember'
				}
			],
			ordinals: []
		},
		en: {
			calendarEras: {
				/* B.C.E. and BCE need to come before B.C. and BC */
				'B.C.E.': 'B.C.E.',
				BCE: 'B.C.E.',
				'B.C.': 'B.C.',
				BC: 'B.C.'
			},
			modifiers: {
				/* after and before must come before aft and bef */
				about: 'Abt.',
				abt: 'Abt.',
				after: 'Aft.',
				aft: 'Aft.',
				around: 'Abt.',
				before: 'Bef.',
				bef: 'Bef.',
				ca: 'Abt.',
				circa: 'Abt.',
				near: 'Abt.'
			},
			months: [
				{
					abbr: 'jan',
					days: 31,
					name: 'january'
				},
				{
					abbr: 'feb',
					days: 29,
					name: 'february'
				},
				{
					abbr: 'mar',
					days: 31,
					name: 'march'
				},
				{
					abbr: 'apr',
					days: 30,
					name: 'april'
				},
				{
					abbr: 'may',
					days: 31,
					name: 'may'
				},
				{
					abbr: 'jun',
					days: 30,
					name: 'june'
				},
				{
					abbr: 'jul',
					days: 31,
					name: 'july'
				},
				{
					abbr: 'aug',
					days: 31,
					name: 'august'
				},
				{
					abbr: 'sep',
					days: 30,
					name: 'september'
				},
				{
					abbr: 'oct',
					days: 31,
					name: 'october'
				},
				{
					abbr: 'nov',
					days: 30,
					name: 'november'
				},
				{
					abbr: 'dec',
					days: 31,
					name: 'december'
				}
			],
			ordinals: ['0th', '1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '11th', '12th', '13th']
		},
		es: {
			calendarEras: {
				'a C': 'a. C.',
				'a. C.': 'a. C.',
				AEC: 'AEC'
			},
			modifiers: {
				/* antes, aproximadamente, and ca must come before ant, aprox, and c */
				antes: 'antes',
				ant: 'ant.',
				aproximadamente: 'aproximadamente',
				aprox: 'aprox.',
				ca: 'ca',
				c: 'c.',
				despu\u00e9s: 'despu\u00e9s',
				dps: 'dps',
				est: 'est.'
			},
			months: [
				{
					abbr: 'ene',
					days: 31,
					name: 'enero'
				},
				{
					abbr: 'feb',
					days: 29,
					name: 'febrero'
				},
				{
					abbr: 'mar',
					days: 31,
					name: 'marzo'
				},
				{
					abbr: 'abr',
					days: 30,
					name: 'abril'
				},
				{
					abbr: 'mayo',
					days: 31,
					name: 'mayo'
				},
				{
					abbr: 'jun',
					days: 30,
					name: 'junio'
				},
				{
					abbr: 'jul',
					days: 31,
					name: 'julio'
				},
				{
					abbr: 'ago',
					days: 31,
					name: 'agosto'
				},
				{
					abbr: 'set',
					days: 30,
					name: 'septiembre'
				},
				{
					abbr: 'oct',
					days: 31,
					name: 'octubre'
				},
				{
					abbr: 'nov',
					days: 30,
					name: 'noviembre'
				},
				{
					abbr: 'dic',
					days: 31,
					name: 'diciembre'
				}
			],
			ordinals: ['0\u00ba', '1\u00ba', '2\u00ba', '3\u00ba', '4\u00ba', '5\u00ba', '6\u00ba', '7\u00ba', '8\u00ba', '9\u00ba']
		},
		fr: {
			calendarEras: {
				AEC: 'AEC',
				'av J-C': 'av. J-C',
				'av. J-C': 'av. J-C'
			},
			modifiers: {
				/* ca, cca, and circa must come before c */
				apr\u00e8s: 'apr\u00e8s',
				avant: 'avant',
				ca: 'ca',
				cca: 'cca',
				circa: 'circa',
				c: 'c.',
				environ: 'environ',
				vers: 'vers'
			},
			months: [
				{
					abbr: 'jan',
					days: 31,
					name: 'janvier'
				},
				{
					abbr: 'f\u00e9v',
					days: 29,
					name: 'f\u00e9vrier'
				},
				{
					abbr: 'mars',
					days: 31,
					name: 'mars'
				},
				{
					abbr: 'avr',
					days: 30,
					name: 'avril'
				},
				{
					abbr: 'mai',
					days: 31,
					name: 'mai'
				},
				{
					abbr: 'juin',
					days: 30,
					name: 'juin'
				},
				{
					abbr: 'jul',
					days: 31,
					name: 'juillet'
				},
				{
					abbr: 'ao\u00fbt',
					days: 31,
					name: 'ao\u00fbt'
				},
				{
					abbr: 'sept',
					days: 30,
					name: 'septembre'
				},
				{
					abbr: 'oct',
					days: 31,
					name: 'octobre'
				},
				{
					abbr: 'nov',
					days: 30,
					name: 'novembre'
				},
				{
					abbr: 'd\u00e9c',
					days: 31,
					name: 'd\u00e9cembre'
				}
			],
			ordinals: ['1er', '2e', '3e', '4e', '5e', '6e', '7e', '8e', '9e', '0e', '1e']
		},
		it: {
			calendarEras: {
				'a.C.': 'a.C.',
				'a.e.v.': 'a.e.v.',
				aC: 'a.C.',
				aev: 'a.e.v.'
			},
			modifiers: {
				circa: 'circa',
				dopo: 'dopo',
				prima: 'prima'
			},
			months: [
				{
					abbr: 'gen',
					days: 31,
					name: 'gennaio'
				},
				{
					abbr: 'feb',
					days: 29,
					name: 'febbraio'
				},
				{
					abbr: 'mar',
					days: 31,
					name: 'marzo'
				},
				{
					abbr: 'apr',
					days: 30,
					name: 'aprile'
				},
				{
					abbr: 'mag',
					days: 31,
					name: 'maggio'
				},
				{
					abbr: 'giu',
					days: 30,
					name: 'giugno'
				},
				{
					abbr: 'lug',
					days: 31,
					name: 'luglio'
				},
				{
					abbr: 'ago',
					days: 31,
					name: 'agosto'
				},
				{
					abbr: 'set',
					days: 30,
					name: 'settembre'
				},
				{
					abbr: 'ott',
					days: 31,
					name: 'ottobre'
				},
				{
					abbr: 'nov',
					days: 30,
					name: 'novembre'
				},
				{
					abbr: 'dic',
					days: 31,
					name: 'dicembre'
				}
			],
			ordinals: ['0\u00ba', '1\u00ba', '2\u00ba', '3\u00ba', '4\u00ba', '5\u00ba', '6\u00ba', '7\u00ba', '8\u00ba', '9\u00ba']
		},
		sv: {
			calendarEras: {
				'f.Kr.': 'f.Kr.',
				'f.v.t.': 'f.v.t.',
				fKr: 'f.Kr.',
				fvt: 'f.v.t.'
			},
			modifiers: {
				/* efter and f\u00f6re must come before e and f */
				circa: 'circa',
				cirka: 'cirka',
				efter: 'efter',
				e: 'e.',
				f\u00f6re: 'f\u00f6re',
				f: 'f.',
				om: 'om'
			},
			months: [
				{
					abbr: 'jan',
					days: 31,
					name: 'januari'
				},
				{
					abbr: 'feb',
					days: 29,
					name: 'februari'
				},
				{
					abbr: 'mar',
					days: 31,
					name: 'mars'
				},
				{
					abbr: 'apr',
					days: 30,
					name: 'april'
				},
				{
					abbr: 'maj',
					days: 31,
					name: 'maj'
				},
				{
					abbr: 'juni',
					days: 30,
					name: 'juni'
				},
				{
					abbr: 'juli',
					days: 31,
					name: 'juli'
				},
				{
					abbr: 'aug',
					days: 31,
					name: 'augusti'
				},
				{
					abbr: 'sep',
					days: 30,
					name: 'september'
				},
				{
					abbr: 'okt',
					days: 31,
					name: 'oktober'
				},
				{
					abbr: 'nov',
					days: 30,
					name: 'november'
				},
				{
					abbr: 'dec',
					days: 31,
					name: 'december'
				}
			],
			ordinals: []
		}
	};
	const months = ui.localize(langSets, 'months');
	const modifiers = ui.localize(langSets, 'modifiers');
	const ordinals = ui.localize(langSets, 'ordinals');
	const calendarEras = ui.localize(langSets, 'calendarEras');
	const validator = {
		extractData(str) {
			const parts = str
				.replace(/,/g, ' ') /* commas to spaces */
				.replace(/\//g, ' ') /* slashes to spaces */
				.replace(/-/g, ' ') /* hyphens to spaces */
				.replace(/\./g, ' ') /* dots to spaces */
				.replace(/\s{2,}/g, ' ') /* multi-space to single-space */
				.trim()
				.split(' ');
			const terms = [];
			const mods = [];
			const unknowns = [];
			parts.forEach(term => {
				const mod = this.isModifier(term);
				if (mod) {
					mods.push(mod);
				} else if (this.isUnknown(term)) {
					unknowns.push(term);
				} else if (term !== '') {
					terms.push(this.processTerm(term));
				}
			});
			return {
				modifiers: mods,
				terms,
				unknowns
			};
		},
		filterCalendarEra(str) {
			let era;
			let filteredString = str;
			for (const eraPattern in calendarEras) {
				if (calendarEras.hasOwnProperty(eraPattern)) {
					const rex = new RegExp(eraPattern, 'i');
					const match = rex.test(filteredString);
					if (match) {
						filteredString = filteredString.replace(rex, '');
						era = calendarEras[eraPattern];
						break;
					}
				}
			}
			return {
				era,
				str: filteredString.trim()
			};
		},
		formatDoubleYear(year) {
			const doubleYearMinLength = 2;
			let matchingDoubleYear = ((year + 1) % 100).toString();
			if (matchingDoubleYear.length < doubleYearMinLength) {
				matchingDoubleYear = `0${matchingDoubleYear}`;
			}
			return matchingDoubleYear;
		},
		generate1TermDates(terms) {
			/* Possibilities: M, Y */
			const dates = [];
			const [term] = terms;
			if (term.month) {
				dates.push({
					month: term.month,
					monthAbbr: term.monthAbbr
				});
			}
			if (term.year && term.integer !== 0) {
				dates.push({
					year: term.integer
				});
			}
			return dates;
		},
		generate2TermDates(terms, nonUS) {
			/* Possibilities: M / D, D / M, M / Y, Y / DY, Y / M */
			const dates = [];
			const [first, second] = terms;
			if (first.month && second.day) {
				dates.push({
					day: second.integer,
					month: first.month,
					monthAbbr: first.monthAbbr
				});
			}
			if (first.day && second.month && (first.isOrdinal || (first.integer !== second.integer))) {
				const dm = {
					day: first.integer,
					month: second.month,
					monthAbbr: second.monthAbbr
				};
				if (nonUS) {
					dates.unshift(dm);
				} else {
					dates.push(dm);
				}
			}
			if (first.month && second.year) {
				dates.push({
					month: first.month,
					monthAbbr: first.monthAbbr,
					year: second.integer
				});
			}
			if (first.year && this.isValidDoubleYear(first.integer, second)) {
				dates.push({
					doubleYear: this.formatDoubleYear(first.integer),
					year: first.integer
				});
			}
			if (first.year && second.month && (first.integer !== second.integer)) {
				dates.push({
					month: second.month,
					monthAbbr: second.monthAbbr,
					year: first.integer
				});
			}
			return dates;
		},
		generate3TermDates(terms, nonUS) {
			/* Possiblities: M / D / Y, D / M / Y, M / Y / DY, Y / M / D */
			const dates = [];
			const [first, second, third] = terms;
			if (first.month && second.day && third.year) {
				dates.push({
					day: second.integer,
					month: first.month,
					monthAbbr: first.monthAbbr,
					year: third.integer
				});
			}
			if (first.day && second.month && third.year && (first.isOrdinal || (first.integer !== second.integer))) {
				const dmy = {
					day: first.integer,
					month: second.month,
					monthAbbr: second.monthAbbr,
					year: third.integer
				};
				if (nonUS) {
					dates.unshift(dmy);
				} else {
					dates.push(dmy);
				}
			}
			if (first.month && second.year && this.isValidDoubleYear(second.integer, third, false, first.month)) {
				dates.push({
					doubleYear: this.formatDoubleYear(second.integer),
					month: first.month,
					monthAbbr: first.monthAbbr,
					year: second.integer
				});
			}
			if (first.year && second.month && third.day && (third.isOrdinal || (first.integer !== third.integer))) {
				dates.push({
					day: third.integer,
					month: second.month,
					monthAbbr: second.monthAbbr,
					year: first.integer
				});
			}
			return dates;
		},
		generate4TermDates(terms, nonUS) {
			/* Possibilities: M / D / Y / DY, D / M / Y / DY */
			const dates = [];
			const [first, second, third, fourth] = terms;
			if (first.month && second.day && third.year && this.isValidDoubleYear(third.integer, fourth, second.integer, first.month)) {
				dates.push({
					day: second.integer,
					doubleYear: this.formatDoubleYear(third.integer),
					month: first.month,
					monthAbbr: first.monthAbbr,
					year: third.integer
				});
			}
			if (first.day && second.month && third.year && this.isValidDoubleYear(third.integer, fourth, first.integer, second.month) && (first.isOrdinal || (first.integer !== second.integer))) {
				const dmyy = {
					day: first.integer,
					doubleYear: this.formatDoubleYear(third.integer),
					month: second.month,
					monthAbbr: second.monthAbbr,
					year: third.integer
				};
				if (nonUS) {
					dates.unshift(dmyy);
				} else {
					dates.push(dmyy);
				}
			}
			return dates;
		},
		getDaysInMonth(month, year) {
			const isFebruary = month === 2;
			let days = months[month - 1].days;
			if (isFebruary && year && !this.isLeapYear(year)) {
				days = 28;
			}
			return days;
		},
		getGenealogicalDate(data) {
			let dateString = '';
			if (data.mods && data.mods.length) {
				dateString += `${data.mods[0]} `;
			}
			if (data.date.month) {
				if (data.date.day) {
					dateString += `${data.date.day} `;
				}
				dateString += data.date.monthAbbr;
			}
			if (data.date.year) {
				dateString += data.date.month ? ` ${data.date.year}` : data.date.year;
				if (data.date.doubleYear) {
					dateString += `/${data.date.doubleYear}`;
				} else if (data.era) {
					dateString += ` ${data.era}`;
				}
			}
			return dateString.length ? dateString : false;
		},
		getNumericMonth(str) {
			const minNonMonthNum = 13;
			const minNonMonthLength = 3;
			let numericMonth = 0;
			if (!isNaN(str) && str > 0 && str < minNonMonthNum) {
				numericMonth = Number(str);
			} else if (isNaN(str) && str !== false) {
				months.forEach((month, i) => {
					const lowerStr = str.toLowerCase();
					if (lowerStr === month.abbr || (lowerStr.length > minNonMonthLength && lowerStr === month.name.substr(0, lowerStr.length))) {
						numericMonth = i + 1;
					}
				});
			}
			return numericMonth;
		},
		init(value) {
			const filtered = this.filterCalendarEra(value);
			const extracted = this.extractData(filtered.str);
			const nonUS = ui.lang !== 'en' && ui.lang !== 'en-us';
			const dates = [];
			let isValidFormat = false;
			let variations = [];
			const variationValues = [
				() => this.generate1TermDates(extracted.terms),
				() => this.generate2TermDates(extracted.terms, nonUS),
				() => this.generate3TermDates(extracted.terms, nonUS),
				() => this.generate4TermDates(extracted.terms, nonUS)
			];
			if (extracted.terms.length) {
				variations = variationValues[extracted.terms.length - 1]();
			}
			variations.forEach(variation => {
				let genealogical;
				let isValid = true;
				if (variation.day && variation.month && !this.isDayInMonth(variation.day, variation.month, variation.year)) {
					isValid = false;
				}
				if (isValid) {
					genealogical = this.getGenealogicalDate({
						era: filtered.era,
						date: variation,
						mods: extracted.modifiers
					});
					if (genealogical === value) {
						isValidFormat = true;
					}
					dates.push({
						day: variation.day,
						month: variation.month,
						monthAbbr: variation.monthAbbr,
						year: variation.year,
						doubleYear: variation.doubleYear,
						genealogical,
						isFuture: validator.isFutureDate(variation)
					});
				}
			});
			return {
				dates,
				explicit: dates.length === 1 && dates[0].genealogical === value,
				modifiers: extracted.modifiers,
				original: value,
				termsLength: extracted.terms.length,
				unknowns: extracted.unknowns,
				valid: isValidFormat
			};
		},
		isDayInMonth(day, month, year) {
			const numericMonth = this.getNumericMonth(month);
			const daysInMonth = this.getDaysInMonth(numericMonth, year);
			return day > 0 && day <= daysInMonth;
		},
		isFutureDate(date) {
			let future = false;
			if (date.year) {
				const dateNow = new Date();
				if (date.year === dateNow.getFullYear()) {
					if (date.month) {
						if (date.month - 1 === dateNow.getMonth()) {
							if (date.day) {
								future = date.day > dateNow.getDate();
							}
						} else {
							future = date.month - 1 > dateNow.getMonth();
						}
					}
				} else {
					future = date.year > dateNow.getFullYear();
				}
			}
			return future;
		},
		isLeapYear(year) {
			const leapDay = 29;
			return new Date(year, 1, leapDay).getMonth() === 1;
		},
		isModifier(str) {
			const loweredStr = str.toLowerCase();
			const minNumOfPredictiveLetters = 3;
			let match = false;
			if (modifiers.hasOwnProperty(loweredStr)) {
				match = modifiers[loweredStr];
			} else if (loweredStr.length > minNumOfPredictiveLetters) {
				for (const mod in modifiers) {
					if (modifiers.hasOwnProperty(mod) && loweredStr === mod.substr(0, loweredStr.length)) {
						match = modifiers[mod];
					}
				}
			}
			return match;
		},
		isOrdinal(str) {
			const minOrdinalLength = 2;
			let returnValue = false;
			if (typeof str === 'string' && str.length >= minOrdinalLength) {
				const loweredStr = str.toLowerCase();
				const lastTwoLetters = loweredStr.substr(-2);
				const lastThreeLetters = loweredStr.substr(-3);
				const lastFourLetters = loweredStr.substr(-4);
				returnValue = ordinals.indexOf(lastTwoLetters) >= 0 || ordinals.indexOf(lastThreeLetters) >= 0 || ordinals.indexOf(lastFourLetters) >= 0;
			}
			return returnValue;
		},
		isUnknown(str) {
			const loweredStr = str.toLowerCase();
			return !this.isOrdinal(loweredStr) && isNaN(Number(loweredStr)) && this.getNumericMonth(loweredStr) === 0 && !this.isModifier(loweredStr);
		},
		isValidDay(day) {
			const minNonMonthDays = 32;
			const dayNumber = Number(day);
			const dayInteger = parseInt(day, 10);
			return (!isNaN(dayNumber) && dayNumber > 0 && dayNumber < minNonMonthDays) || (this.isOrdinal(day) && dayInteger > 0 && dayInteger < minNonMonthDays);
		},
		isValidDoubleYear(year1, term2, day, month) {
			/*  1582 <= (both Y1 and Y2) <= 1752, Jan <= M <= Mar,
				D any valid day in Jan and Feb, but any valid day < 25 in March	*/
			let valid = false;
			if (this.isYearInDoubleRange(year1)) {
				const year1LastTwo = year1 % 100;
				const year1LastOne = year1LastTwo % 10;
				const year2Length = term2.integer.toString().length;
				const treatOneDigitAsTwo = year2Length === 1 && term2.original === `0${term2.integer}`;
				const decadeChange = -9;
				const centuryChange = -99;
				const valid4Digit = this.isYearInDoubleRange(term2.integer) && (term2.integer - year1 === 1);
				const valid2Digit = (year2Length === 2 || treatOneDigitAsTwo) && ((term2.integer - year1LastTwo === 1) || (term2.integer - year1LastTwo === centuryChange));
				const valid1Digit = (year2Length === 1 && !treatOneDigitAsTwo) && ((term2.integer - year1LastOne === 1) || (term2.integer - year1LastOne === decadeChange));
				if (valid4Digit || valid2Digit || valid1Digit) {
					valid = true;
					if (month) {
						valid = false;
						const marchNum = 3;
						if (month <= marchNum) {
							valid = true;
							if (day) {
								if (month === marchNum) {
									const maxDayInMarch = 25;
									valid = day < maxDayInMarch;
								} else {
									valid = this.isDayInMonth(day, month, year1);
								}
							}
						}
					}
				}
			}
			return valid;
		},
		isValidYear(year) {
			const numericYear = Number(year);
			const maxValidYear = 2200;
			return !isNaN(numericYear) && numericYear >= 0 && numericYear < maxValidYear;
		},
		isYearInDoubleRange(year) {
			const minDoubleYear = 1581;
			const maxDoubleYear = 1753;
			return year > minDoubleYear && year < maxDoubleYear;
		},
		processTerm(str) {
			const numeric = this.getNumericMonth(str);
			return {
				day: this.isValidDay(str),
				integer: parseInt(str, 10),
				isOrdinal: this.isOrdinal(str),
				month: numeric,
				monthAbbr: numeric ? ui.ucfirst(months[numeric - 1].abbr) : undefined,
				original: str,
				year: this.isValidYear(str)
			};
		}
	};
	$.dateValidator = value => validator.init(value);
	$.dateValidator.getTest = () => validator;
})(jQuery);
